<div class="backdrop" [class.show]="state.isOpen" (click)="state.hide()"></div>

<aside class="sidebar" [class.show]="state.isOpen">
  <div class="sidebar__header shadow-sm" *ngIf="!isQueryParams">
    <div class="sidebar__logo">
      <a routerLink="/" class="d-inline-block" (click)="state.hide()">
        <img src="assets/images/logo2.svg" width="100" class="vam_logo" />
      </a>
    </div>

    <button class="btn-close" (click)="state.hide()">
      <ion-icon name="close-outline" class="ion-lg"></ion-icon>
    </button>
  </div>

  <div class="sidebar__body">
    <ul class="sidebar__lists list-unstyled">
      <li class="sidebar__item">
        <a routerLink="/vam/information" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_information' | translate }}
        </a>
      </li>
      <li class="sidebar__item">
        <a routerLink="/vam/options" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_options' | translate }}
        </a>
      </li>
      <li class="sidebar__item">
        <a routerLink="/vam/flags" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_flags' | translate }}
        </a>
      </li>
      <li class="sidebar__item">
        <a routerLink="/vam/rating" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_rating' | translate }}
        </a>
      </li>
      <li class="sidebar__item" *ngIf="estimatePermission.includes(role)">
        <a routerLink="/vam/estimates" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_estimates' | translate }}
        </a>
      </li>
      <li class="sidebar__item">
        <a routerLink="/vam/gallery" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_gallery' | translate }}
        </a>
      </li>
      <li class="sidebar__item">
        <a routerLink="/vam/offline-data" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_offline_data' | translate }}
        </a>
      </li>
      <li class="sidebar__item" *ngIf="mediaAdmin.includes(role)">
        <a routerLink="/media" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'media' | translate }}
        </a>
      </li>
      <li
        class="sidebar__item"
        *ngIf="
          [
            'admin',
            'purchasemanager',
            'purchaser',
            'media_admin',
            'salesmanager',
            'salesperson',
            'new_sales_manager',
            'new_salesman',
            'reconditioning_manager',
            'reconditioning_executive'
          ].includes(role)
        "
      >
        <a target="_blank" routerLink="/report" [routerLinkActive]="['active']" class="sidebar__link" (click)="state.hide()">
          {{ 'nav_report' | translate }}
        </a>
      </li>
      <li class="sidebar__item" *ngIf="!isQueryParams">
        <a href="javascript:void(0)" class="sidebar__link logout" (click)="logout()">
          <span class="icon icon-3x mr-2">
            <img src="assets/images/logout2.svg" />
          </span>
          {{ 'logout' | translate }}
        </a>
      </li>
    </ul>
  </div>
</aside>
